/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';

import pxInRem from 'shared/helpers/styled-components/remHelper';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import breakpoints from 'shared/../shared/constants/breakpoints';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

const Wrapper = styled.div`
  position: relative;
  max-width: 1000px;
  margin: auto;
  padding: 0 40px;
  overflow: visible;
  font-family: ${FONT_FAMILIES.brand};
  font-weight: ${FONT_WEIGHTS.demi};

  &&& .slick-prev {
    left: -40px;
  }

  &&& .slick-next {
    right: -40px;
  }
`;

const Day = styled.div`
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${pxInRem('11px')};
  font-weight: ${FONT_WEIGHTS.bold};
  color: ${props =>
    props.active
      ? props.theme.tvGuide.days.color.active
      : props.theme.tvGuide.days.color.default};

  ${mediaQueries.toPhablet`
    text-transform: uppercase;
    font-size: ${pxInRem('15px')};
    color: ${props => props.theme.tvGuide.days.color.active}
  `};
`;

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  width: 100%;
  line-height: 40px;
`;

const Slide = styled.div``;

// eslint-disable-next-line react/prefer-stateless-function
export default class Days extends React.PureComponent {
  displayName = 'Days';

  constructor(props) {
    super(props);
    this.dayLinkElements = {};
  }

  onSlide = (oldIndex, newIndex) => {
    const { routerPush } = this.props;
    if (window.matchMedia(`(max-width: ${breakpoints.phablet})`).matches) {
      const item = this.dayLinkElements[newIndex];
      routerPush(item.props.to);
    }
  };

  render() {
    const { sliderConfig, days, className, bigram } = this.props;

    return (
      <Wrapper className={className}>
        <Slider {...sliderConfig} beforeChange={this.onSlide}>
          {days.map((day, index) => (
            <Slide data-index={index} key={`Day${index}`}>
              <Day active={day.active}>
                <StyledLink
                  ref={el => {
                    this.dayLinkElements[index] = el;
                  }}
                  to={`/${bigram}/guide-tv-cette-semaine/${day.slug}-${index}`}
                >
                  {day.label}
                </StyledLink>
              </Day>
            </Slide>
          ))}
        </Slider>
      </Wrapper>
    );
  }
}
